<template>
    <div class="full-width flex align-center + justify-between passage__item">
        <div class="flex align-center">
            <!-- {{ props.one.passageAccuracyRate }} -->
            <!-- // 맞춤 - 맞춤학습
        // 수능 - 수능모의평가
        // 추천학습(수동) - 추천학습
        // 추천학습(자동) - 추천학습
        // 추천학습(진단) - 진단추천
        // 리셋 - 리셋
        // 추천학습  리셋 - 추천학습리셋
        // 수능모의평가 리셋 - 수능모의평가 리셋 -->
            <span v-if="type === 100" class="mapBoxTtTag blue">맞춤학습</span>
            <span v-if="type === 200" class="mapBoxTtTag green">맞춤학습</span>
            <span v-if="type === 300" class="mapBoxTtTag red">수능모의평가</span>
            <span v-if="type === 400" class="mapBoxTtTag pink">추천학습</span>
            <span v-if="type === 500" class="mapBoxTtTag purple">추천학습</span>

            <span v-if="type === 600" class="mapBoxTtTag pink">진단추천</span>
            <span v-if="type === 700" class="mapBoxTtTag pink">수능모의평가 리셋</span>
            <span v-if="type === 800" class="mapBoxTtTag pink">추천학습 리셋</span>
            <span v-if="type === 900" class="mapBoxTtTag pink">맞춤리셋</span>

            <!-- <q-chip v-if="props?.isTop" dense color="#eaf8ee" size="md">{{ props.one.learningType }}</q-chip> -->
            <span v-if="props.one.passageArea" class="mapBoxTtMoon" style="display: inline-block; width: 4vw">{{ props.one.passageArea }} </span>
            <!-- <span class="mapBoxTtMoon">{{ props.one.passageArea }} </span> -->
            <span class="mapBoxTtLevles" style="min-width: 8.5vw">{{ props.one.level }} &nbsp;&nbsp;{{ props.one.lesson }}</span>
            <!-- <div class="barVertical" /> -->
            <template v-if="type !== 300 && type !== 700">
                <span class="mapBoxTtNormal" style="min-width: 10vw">{{ props.one.passageNumber }} &nbsp;-&nbsp;{{ props.one.passageClass }} </span>
                <span class="mapBoxTtNormal passageName"> {{ props.one.passageName }}</span>
            </template>
        </div>
        <!-- <div class="mapBoxTtPer" v-if="props.one.passageAccuracyRate > -1">{{ props.one.passageAccuracyRate }}%</div> -->
    </div>
</template>

<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';
import Comm from '@/components/common.js';

const props = defineProps({
    isTop: {
        Type: Boolean,
        required: true,
    },
    one: {
        Type: Object,
        required: true,
    },
});

// const typeHtml = computed(() => {
//     const text = props.one.learningType;
//     let color = 'blue';
//     // 맞춤학습은 위 아래 색깔이 다르다.
//     if (text.includes('맞춤학습'))
//         if (props.isTop) color = 'blue';
//         else color = 'green';

//     if (text.includes('추천학습')) color = 'red';
//     if (text.includes('맞춤리셋')) color = 'pink';
//     if (text.includes('추천리셋')) color = 'purple';
//     if (text.includes('수능')) color = 'blue';
//     if (text.includes('수능모의평가 리셋')) color = 'blue';

//     return `<span class="mapBoxTtTag ${color}">${text}</span>`;
// });
const type = computed(() => {
    return Comm.getNoOfStudyType(true, props.one.learningType);
    // const text = props.one.learningType;
    // 맞춤학습은 위 아래 색깔이 다르다.
    // if (text.includes('맞춤학습'))
    //     if (props.isTop) return 100;
    //     else return 200;
    // if (text.includes('추천학습')) return 300;
    // if (text.includes('맞춤리셋')) return 400;
    // if (text.includes('추천리셋')) return 500;
    // if (text.includes('수능모의평가 리셋')) return 600;
    // if (text.includes('수능')) return 700;
    // return null;
});
// watch(props.kind, (newProps, oldProps) => {
//     console.log('--watch-props-newProps', newProps);
//     console.log('--watch-props-oldProps', oldProps);
// });

// const kind = computed(() => props.kind);

onMounted(() => {
    // console.log('--one-props-', props.one);
});
////////////////////////////----OnClick----////////////////////////////
// const onMㄴㅇㄹㅇㄴㄹㄴㅇㄹInfo = () => {};
</script>

<style scoped lang="scss">
// .blue {
//     background-color: #d8f6ff;
// }
// .green {
//     background-color: #eaf8ee;
// }
// .pink {
//     background-color: #fbebef;
// }
// .purple {
//     background-color: #e8dfff;
// }
// .red {
//     background-color: #fbebef;
// }

.passage__item {
    padding: 1.33vmin 0;

    &:first-of-type {
        padding-top: 0;
    }

    &:last-of-type {
        padding-bottom: 0;
    }
}

.mapBoxTtTag {
    margin-left: 0;
    padding: 0.58vmin 1.33vmin;
}
.passageName {
    display: inline-block;
    @include text-ellipsis;
    max-width: 26vw;
}
</style>
